var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M13.5-.003h-3V6.5H0v3h10.5v6.502h3V9.5H24v-3H13.5V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M18.457 10.783L24 13.864v-3.082h-5.543zm-3.847 0l9.39 5.22v-1.478l-6.735-3.742H14.61zm6.885 5.22L14.61 12.17v3.833h6.885z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M14.61 10.783l9.39 5.22v-1.478l-6.735-3.742H14.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M14.61 10.783l9.39 5.22v-1.478l-6.735-3.742H14.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M4.237 10.783L0 13.137v-2.354h4.237zm5.153.66v4.56H1.192l8.198-4.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.735 10.783L0 14.524v1.478l9.39-5.22H6.735z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M5.543 5.217L0 2.135v3.082h5.543zm3.847 0L0-.003v1.478l6.735 3.742H9.39zM2.505-.003L9.39 3.83V-.003H2.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M9.39 5.217L0-.003v1.478l6.735 3.742H9.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M9.39 5.217L0-.003v1.478l6.735 3.742H9.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M19.762 5.217L24 2.862v2.355h-4.238zm-5.152-.66v-4.56h8.197l-8.197 4.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M17.265 5.217L24 1.475V-.003l-9.39 5.22h2.655z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/UnitedKingdom.f7c104a6ab1a92193fd28edd8798da10.svg";
export { ForwardRef as ReactComponent };